import { render } from "./PvDropdown.vue?vue&type=template&id=dfe3a184"
import script from "./PvDropdown.vue?vue&type=script&lang=js"
export * from "./PvDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__